import { render } from "./Student.vue?vue&type=template&id=864d5288&scoped=true"
import script from "./Student.vue?vue&type=script&lang=js"
export * from "./Student.vue?vue&type=script&lang=js"

import "./Student.vue?vue&type=style&index=0&id=864d5288&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-864d5288"]])

export default __exports__